import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function onboardTeamMember(data) {
    var url = process.env.REACT_APP_API_BASE_URL + `/onboard_user`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getMyTeams() {
    var url = process.env.REACT_APP_API_BASE_URL + `/my_teams`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function createTeam(name) {
    var url = process.env.REACT_APP_API_BASE_URL + `/teams`;
    return axios.post(url, { name }, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamMembers(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateMemberStatus(team_uuid, user_uuid, status) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team/${team_uuid}/member/${user_uuid}/status`;
    return axios.post(url, { status }, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateMemberAvatar(team_uuid, user_uuid, file) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team/${team_uuid}/member/${user_uuid}/avatar`;
    const data = new FormData();
    data.append("avatar", file);
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" } });
}

export function removeTeamMember(team_uuid, user_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team/${team_uuid}/member/${user_uuid}`;
    return axios.delete(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function renameTeam(team_uuid, name) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team/${team_uuid}/name`;
    return axios.post(url, { name }, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamStatistics(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/statistics/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamLatestFiles(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/latest_files/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamFiles(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/team_files/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateCredits(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/get_credits/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getTeamPlan(team_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/tier/` + team_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}
